<form (submit)="done($event)">
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="form-group" [formGroup]="formulario" *ngFor="let field of fields" [ngClass]="field.classCol">
          <label class="col-form-label" *ngIf="field.type === 'select'">{{ field.title }}</label>
          <div [ngSwitch]="field.type">
            <app-field-input-ng-select *ngSwitchCase="'auto-complete'"
              [formControlName]="field.field" [search]="field.autoComplete"
              displayField="text" valueField="value" [displayLabel]="field.title"
              [container]="null" [minLengthToSearch]="field.customConfig?.minLengthToSearch || 0">
            </app-field-input-ng-select>

            <app-field-input-date *ngSwitchCase="'datepicker'"
              [formControlName]="field.field" [displayLabel]="field.title"
              [viewMode]="field.customConfig?.dateViewMode || 'day'"
              [format]="field.customConfig?.format">
            </app-field-input-date>

            <select *ngSwitchCase="'select'" class="form-control" [formControlName]="field.field">
              <option *ngFor="let item of field.items" [value]="item.value">{{ item.text }}</option>
            </select>

            <app-field-input-text *ngSwitchDefault
              [formControlName]="field.field" [displayLabel]="field.title">
            </app-field-input-text>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-success">Filtrar</button>
      <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">Cancelar</button>
    </div>
  </div>
</form>
